export default { sha: '3169621c92357cc34d197ac32d07a25d0a7fdf15', buildNumber: 'undefined' }
